import React from "react";
import Select, { components, MenuProps } from "react-select";

interface Props {
  value: string;
  name: any;
  placeholder: string;
  type: any;
  options: any;
  onChange: (e: any) => void;
  errors: any;
  clickSubmit: boolean;
  // Fixed action rendered below the options, e.g. "Add Organisation +".
  menuFooter?: { label: string; onClick: () => void };
}

// Defined at module level so react-select doesn't remount the menu on every render.
const MenuWithFooter = (props: MenuProps<any>) => {
  const menuFooter = (props.selectProps as any).menuFooter as Props["menuFooter"];
  return (
    <components.Menu {...props}>
      {props.children}
      {menuFooter && (
        <button
          type="button"
          className="select-menu-footer"
          // Prevent react-select from treating the click as a blur/close before onClick fires.
          onMouseDown={(e) => e.preventDefault()}
          onClick={menuFooter.onClick}
        >
          <span>{menuFooter.label}</span>
          <span className="select-menu-footer__icon">+</span>
        </button>
      )}
    </components.Menu>
  );
};

const SelectController = (props: Props) => {
  return (
    <div className="input-container-wrapper me-3">
      <label htmlFor="">{props.placeholder}</label>
      <Select
        className="input-control"
        options={props?.options}
        value={props?.value}
        onChange={props?.onChange}
        isSearchable={false}
        placeholder={props?.placeholder}
        {...(props.menuFooter && {
          components: { Menu: MenuWithFooter },
          menuFooter: props.menuFooter,
        } as any)}
      />
      <div className="error-line">
        {props.errors !== null && props.errors.error && props.clickSubmit ? (
          <span>{props.errors.message}</span>
        ) : null}
      </div>
    </div>
  );
};

export default SelectController;
